import Api from '../../../helpers/Api';

export const SET_AFFILIATES_DATA = 'SET_AFFILIATES_DATA';
const setAffiliatesData = (dataAffiliates) => ({
    type: SET_AFFILIATES_DATA,
    dataAffiliates,
});

// ACTIONS

export const getAffiliatesDataIfNeeded = () => (dispatch, getState) => {
    const { dataAffiliates } = getState().affiliates;

    if (dataAffiliates.length < 1) {
        return Api.progressGet(dispatch, '/api/v1/getAffiliatesData')
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setAffiliatesData(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('getAffiliatesDataIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};
